import React from 'react'
import Body from './screen/Body/Body'
import SideNar from './screen/SideNar'

const Routes = () => {
    return (
        <div className="flex-1 flex">
            <SideNar/>
            <Body/>
        </div>
    )
}

export default Routes
